import styled from 'styled-components';
import { Table } from 'semantic-ui-react';
import { breakpointsNumber } from '../../styles';

// floated CTA (download icon) style
export const StyledCTACell = styled(Table.Cell)`
  @media screen and (max-width: ${breakpointsNumber.largeTablet - 1}px) {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;
